import React from 'react'

export default class extends React.Component {
  render() {
    return (
      <div className="phone-frame--wrapper">
        <div>{this.props.children}</div>
      </div>
    )
  }
}
